import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropertyVisitKpis } from '../../../../mappers/property-visit.mapper';

interface TableHeaderSectionProps {
  total: number;
  kpis: PropertyVisitKpis;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, kpis }) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-calendar-check-line ri-22px"></i>
            <h5 className="mx-3 my-0">
              {t('propertyVisits.list.pageTexts.table.title')} ({total})
            </h5>
          </div>
          <div className="d-flex align-items-center">
            <span className="me-1 fw-semibold ms-2">
              {t('propertyVisits.list.pageTexts.table.kpi.toBeReviewed')}
            </span>
            <span className="badge bg-secondary me-2">{kpis?.to_be_reviewed ?? 0}</span>

            <span className="mx-1">|</span>

            <span className="me-1 fw-semibold ms-2">
              {t('propertyVisits.list.pageTexts.table.kpi.needsClarification')}
            </span>
            <span className="badge bg-warning me-2">{kpis?.needs_clarification ?? 0}</span>

            <span className="mx-1">|</span>

            <span className="me-1 fw-semibold ms-2">
              {t('propertyVisits.list.pageTexts.table.kpi.completed')}
            </span>
            <span className="badge bg-success me-2">{kpis?.completed ?? 0}</span>

            <span className="mx-1">|</span>

            <span className="me-1 fw-semibold ms-2">
              {t('propertyVisits.list.pageTexts.table.kpi.notQualified')}
            </span>
            <span className="badge bg-danger">{kpis?.not_qualified ?? 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableHeaderSection;
